import * as React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/shared/lib/utils";

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon | React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: React.ReactNode;
  /** full-card surface (.avizo-card) or inner container */
  card?: boolean;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon: Icon, title, description, action, card = false, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "text-center flex flex-col items-center justify-center",
          card
            ? "avizo-card p-8 sm:p-10 space-y-2"
            : "p-6 rounded-2xl bg-white/5 border border-white/5 space-y-2",
          className
        )}
        {...props}
      >
        {Icon && (
          <div className="mb-2 text-muted-foreground/30 flex items-center justify-center">
            <Icon className="h-8 w-8" />
          </div>
        )}
        <p className="text-sm font-semibold text-foreground">{title}</p>
        {description && (
          <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed max-w-sm mt-1">
            {description}
          </p>
        )}
        {children}
        {action && <div className="mt-4">{action}</div>}
      </div>
    );
  }
);
EmptyState.displayName = "EmptyState";
